<script>
/**
 * @overview 全局分页组件
 *
 * @author huojinzhao
 */

import mapUtils from "@/utils";

export default {
  name: "AppPagination",

  props: {
    list: {
      type: Object,
      default: () => ({}),
    },

    router: {
      type: Boolean,
      default: false,
    },

    size: {
      type: Number,
      required: true,
    },
  },

  methods: {
    ...mapUtils("list", ["routePageIndex"]),

    changeIndex(page) {
      this.router && this.$list_routePageIndex(page);

      this.$emit("changeIndex", page);
    },
  },
};
</script>

<template>
  <el-pagination
    :current-page="list.current_page"
    :page-size="size"
    :total="list.total"
    class="app-pagination"
    layout="total, prev, pager, next"
    @current-change="changeIndex"
  />
</template>

<style lang="postcss">
.app-pagination {
  text-align: center;
}

.app-pagination li,
.app-pagination button {
  background-color: transparent;
}
</style>
